import { useState, useEffect } from 'react';

import { getViewedProductsIds, addViewedProductId } from './utils';

interface Payload {
  excludeProductIds?: number[],
}

export const useViewedProducts = (payload?: Payload) => {
  const [productsIds, setProductsIds] = useState<number[]>([]);

  useEffect(() => {
    const viewedProductsIds = getViewedProductsIds();

    setProductsIds(
      viewedProductsIds?.map((productInfo) => productInfo.id) || [],
    );
  }, [payload?.excludeProductIds?.length]);

  const filteredProductsIds = productsIds.filter((id) => !payload?.excludeProductIds?.includes(id));

  return {
    viewedProductsIds: filteredProductsIds,
    addViewedProductId,
  };
};
